export default {
  graph: null,
  graphTemplates: []
};